module.exports = {"140927100":"龙泉镇","140927101":"义井镇","140927102":"八角镇","140927200":"东湖乡","140927201":"太平庄乡","140927202":"虎北乡","140927203":"贺职乡","140927204":"长畛乡","140927205":"烈堡乡","140927206":"大严备乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140927.json
// module id = 353
// module chunks = 0